import React, { useEffect, useState } from "react";
import BuyerProjectCard from "../../atoms/BuyerProjectCard";
import ProjectListLoader from "../../atoms/ProjectListLoader";
import { fetchProjects } from "../../../utils/API/fetchProjects";
import { useSearchParams } from "react-router-dom";
import Pagination from "../../atoms/Pagination";
import Button from "../../atoms/Button";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getAllWishlist } from "../../../utils/API/getAllWishlistProject";
import { setToWishlist } from "../../../redux/slices/wishlist-slice";
import NotBidNotificationDialog from "../HomePageDialogs/NotBidNotificationDialog";

const ProjectListing = ({ onBid, onInquire, filterData, searchItem }) => {
  const dispatch = useDispatch();
  const [projectsData, setProjectsData] = useState([]);
  const [bidNotNotificationDialogState, setBidNotNotificationDialogState ] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const currentPage = Number(searchParams.get("page")) || 1;
  const [noDataFound, setNoDataFound] = useState(false);

  const [pagination, setPagination] = useState({
    totalItems: 0,
    totalPages: 0,
  });

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await fetchProjects(
        {
          filterData: filterData,
          page: currentPage,
          pageSize: 10,
          searchQuery: searchItem,
        },
        dispatch
      );
      const responseData = response.data;
      setProjectsData(responseData.paginatedData);
      const { totalDocs, totalPages } = responseData;
      setPagination({
        totalItems: totalDocs,
        totalPages: totalPages,
      });
      if (totalDocs === 0) {
        setNoDataFound(true);
      } else {
        setNoDataFound(false);
      }
    } catch (err) {
      setError("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const fetchwishlist = async () => {
    setLoading(true);
    getAllWishlist({ page: 1, pageSize: 0 }, dispatch)
      .then((data) => {
        dispatch(setToWishlist(data.data.paginatedData));
      })

      .catch((error) => {
        console.error("Error fetching wishlist data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchwishlist();
    fetchData();
  }, [currentPage, filterData, searchItem]);

  if (error) {
    return (
      <div className="flex text-xl text-blue-800 font-bold w-full justify-center items-center h-64">
        {error}
      </div>
    );
  }

  return (
    <>
      {loading ? (
        <ProjectListLoader />
      ) : noDataFound ? (
        <div className="text-center py-10 text-3xl font-semibold text-blue-800">Sorry, no results found. Please try adjusting your search criteria</div>
      ) : (
        projectsData.map((project, idx) => (
          <div className="mb-4" key={`project_${idx}`}>
            <BuyerProjectCard
              {...project}
              bidHandler={onBid}
              InquireHandler={onInquire}
              noDataFound={noDataFound}
              setBidNotNotificationDialogState={setBidNotNotificationDialogState}
            />
          </div>
        ))
      )}

      <div className="flex gap-4 mb-6">
        <Pagination
          current={currentPage}
          total={pagination.totalItems}
          pageSize={10}
          setCurrentPage={(page) => setSearchParams({ page })}
        />
        <Button
          onClick={() => {
            navigate("/all-carbon-credit");
          }}
          variant="primary"
          borderColor="blue"
          className="px-10 w-36 font-bold py-2 text-sm rounded-md text-white bg-blue-800"
        >
          See All
        </Button>
      </div>

      <NotBidNotificationDialog
        open={bidNotNotificationDialogState}
        onCancel={() => setBidNotNotificationDialogState(false)}
      />
    </>
  );
};

export default ProjectListing;
